module.exports = __webpack_public_path__ + "img/photo-0088.75056daa.jpg";